import { HttpClient } from 'api/HttpClient';
import { Lender, LoanTerm } from 'enums/ApplicationsVariables';
import { OfferDto } from 'api/OffersApi';

import { ApplicationDto } from './ApplicationApi';

export interface OfferResponseDto {
  minLoanAmount: number;
  maxLoanAmount: number;
  minLoanTerm: string | null;
  lender: Lender;
  loanAmount: number;
  grossLoan: number;
  rate: number;
  apr: number;
  termYears: LoanTerm;
  monthlyPayment: number;
  oneTimeFeePercentage: number;
}

export interface AcceptOfferRequestDto {
  applicationId: string;
  loanAmount: number;
  term: number;
  lender: Lender;
}

export interface AcceptOfferResponseDto {
  isApplicationRejected: boolean;
}

export interface OffersRequestDto {
  applicationId: string;
  loanAmount: number;
}

export interface OffersResponseDto {
  loanOffers: OfferDto[];
  minLoanAmount: number;
  maxLoanAmount: number;
  isApplicationRejected: boolean;
}

export interface DeclineOfferRequestDto {
  applicationId: string;
}

export interface DeclineOfferResponseDto {
  isApplicationRejected: boolean;
}

export interface ConfirmOffersInformationDto {
  applicationId: string;
}

export interface UpdateOfferRequestDto {
  applicationId: string;
  loanAmount: number;
  loanTerm: string;
}

export default class AutomatedOffersApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/automated-offers');
  }

  public async acceptOffer(acceptOfferDto: AcceptOfferRequestDto): Promise<AcceptOfferResponseDto> {
    return this.instance.post('/accept', acceptOfferDto).then((response) => response.data);
  }

  public async getOffer(applicationId: string, loanAmount?: number, loanTerm?: string): Promise<OfferResponseDto> {
    return this.instance
      .get(`/offer?applicationId=${applicationId}&loanAmount=${Number(loanAmount)}&loanTerm=${loanTerm}`)
      .then((response) => response.data);
  }

  public async getOffers(offersRequestDto: OffersRequestDto): Promise<OffersResponseDto> {
    return this.instance.post('', offersRequestDto).then((response) => response.data);
  }

  public async declineOffer(declineOfferDto: DeclineOfferRequestDto): Promise<void> {
    return this.instance.put('/decline', declineOfferDto).then((response) => response.data);
  }

  public async confirmOffersInformation(
    confirmOffersInformationDto: ConfirmOffersInformationDto,
  ): Promise<ApplicationDto> {
    return this.instance
      .put('/confirm-offers-information', confirmOffersInformationDto)
      .then((response) => response.data);
  }

  public async updateOffer(updateOfferDto: UpdateOfferRequestDto): Promise<void> {
    return this.instance.put('', updateOfferDto).then((response) => response.data);
  }
}

export const hilAutomatedOffersApi = new AutomatedOffersApi();
